import { AutocompleteRenderInputParams, InputAdornment, TextField } from "@mui/material";
// components
import Iconify from "src/components/Iconify";
// hooks
import useLocales from "src/hooks/useLocales";

export default function InputFinder(params: AutocompleteRenderInputParams) {
	const { translate } = useLocales();

	return (
		<TextField
			{...params}
			InputProps={{
				...params.InputProps,
				startAdornment: (
					<InputAdornment position='start'>
						<Iconify
							icon={"eva:search-fill"}
							sx={{ ml: 1, width: 20, height: 20, color: "text.disabled" }}
						/>
					</InputAdornment>
				)
			}}
			label={translate("Activo")}
			name='name'
			placeholder={translate("Encuentra tu activo")}
		/>
	);
}
